import styled from '@emotion/styled';
import {
  colors,
  Tooltip,
  TooltipBody,
  useTooltip,
} from '@smartsheet/lodestar-core';
import { Clickable } from '@smartsheet/lodestar-core/dist/esm/components/clickable';
import { ToolbarCopyIcon } from '@smartsheet/lodestar-icons';
import clipboardCopy from 'clipboard-copy';
import React from 'react';
import { useTranslation } from 'react-i18next';

const copyToClipboard = (value: any) => {
  clipboardCopy(value);
};

interface CopyButtonProps {
  value: string | number;
}

const CustomButton = styled(Clickable)`
  display: flex;
  color: ${colors.buttonPrimary};
  &:hover {
    color: ${colors.buttonPrimaryHover};
  }
  &:active {
    color: ${colors.buttonPrimaryPressed};
  }
`;

export const CopyButton = ({ value }: CopyButtonProps) => {
  const { tooltipProps, targetProps } = useTooltip();
  const { t: translate } = useTranslation();

  return (
    <React.Fragment>
      <CustomButton onClick={() => copyToClipboard(value)} {...targetProps}>
        <ToolbarCopyIcon />
      </CustomButton>
      <Tooltip {...tooltipProps}>
        <TooltipBody>{translate('common:copyToClipboard')}</TooltipBody>
      </Tooltip>
    </React.Fragment>
  );
};
